export const IconBookOpen = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconBookOpen_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconBookOpen_svg__a)">
        <path d="M6.5 16q1.175 0 2.287.262 1.113.263 2.213.788V7.2q-1.024-.6-2.175-.9a9.2 9.2 0 0 0-4.112-.125A8.7 8.7 0 0 0 3 6.7v9.9q.875-.3 1.737-.45T6.5 16m6.5 1.05q1.099-.525 2.213-.788a10.268 10.268 0 0 1 4.05-.113q.863.151 1.737.451V6.7a8.7 8.7 0 0 0-1.712-.525 9.2 9.2 0 0 0-4.113.125q-1.15.3-2.175.9zm-1 2.425q-.35 0-.662-.088a2.8 2.8 0 0 1-.588-.237 8.2 8.2 0 0 0-2.05-.862A8.5 8.5 0 0 0 6.5 18q-1.05 0-2.062.275a9 9 0 0 0-1.938.775q-.525.275-1.012-.025A.97.97 0 0 1 1 18.15V6.1q0-.274.137-.525A.86.86 0 0 1 1.55 5.2q1.15-.6 2.4-.9T6.5 4q1.45 0 2.838.375Q10.725 4.75 12 5.5A10.8 10.8 0 0 1 17.5 4q1.3 0 2.55.3t2.4.9q.274.125.413.375.137.25.137.525v12.05a.97.97 0 0 1-.488.875q-.487.3-1.012.025a9 9 0 0 0-1.937-.775A7.8 7.8 0 0 0 17.5 18q-1.125 0-2.2.288-1.075.287-2.05.862-.275.15-.588.238-.312.087-.662.087" />
      </g>
    </svg>
  );
};
